import {
  APP_DATE_FIELDS,
  createDateCodec,
  createDateFieldClassifier,
} from "@skailer-com/uikit/core";

/** Обе функции мутируют переданный объект на месте — на это рассчитывает `api/axios.ts`. */
export const { handleDatesResponse, handleDatesRequest } = createDateCodec(
  createDateFieldClassifier({
    ...APP_DATE_FIELDS,
    ignorePrefixes: [...(APP_DATE_FIELDS.ignorePrefixes ?? []), "date_grain"],
  })
);
